function required(name: keyof ImportMetaEnv, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing environment variable "${name}". Copy .env.example to .env and fill it in.`,
    )
  }
  return value
}

function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

/**
 * Whether the Inventory report tab is backed, and by what.
 *
 * `off` (the default) keeps it Coming soon. `mock` reads sample responses
 * captured from inventory-connect-server, for working on the screens. `live`
 * calls the inventory service's `/v1/inventory/reports` (`VITE_API_INVENTORY_URL`).
 */
export type InventoryReportsMode = 'off' | 'mock' | 'live'

function inventoryReportsMode(value: string | undefined): InventoryReportsMode {
  return value === 'mock' || value === 'live' ? value : 'off'
}

export const env = {
  apiBaseUrl: stripTrailingSlash(required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL)),
  mainApiBaseUrl: stripTrailingSlash(
    required('VITE_MAIN_API_BASE_URL', import.meta.env.VITE_MAIN_API_BASE_URL),
  ),
  /**
   * The inventory service. Optional, unlike the two above: it does not have a host
   * in every environment yet, and its absence must not white-screen the modules
   * that never call it. Empty means "not configured" — see `inventoryHttp`.
   */
  inventoryApiBaseUrl: stripTrailingSlash(import.meta.env.VITE_API_INVENTORY_URL ?? ''),
  appName: import.meta.env.VITE_APP_NAME || 'NexQr Merchant',
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT ?? 20_000),
  inventoryReports: inventoryReportsMode(import.meta.env.VITE_INVENTORY_REPORTS),
  isDev: import.meta.env.DEV,
} as const
